import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export const SmallIntro = () => {
  const isDesktop = window.innerWidth >= 768; // example threshold for mobile screens

  useEffect(() => {
    if (isDesktop) {
      AOS.init();
    }
  }, [isDesktop]);

  return (
    <div
      data-aos={isDesktop ? "fade-right" : undefined}
      data-aos-anchor-placement="top-center"
      data-aos-duration="1000"
      className="smallintro t"
    >
      <div className="small">
        Meticulous Oracle Developer with full-stack capabilities and over 4 years of hands-on experience in PL/SQL, database optimization, and high-performance application development. Proficient in crafting and optimizing complex PL/SQL scripts. Skilled in Python/Django, CI/CD automation (GitLab, Liquibase, Gradle), and cloud ecosystems (AWS, GCP, Docker, Kubernetes) to deliver secure, scalable end-to-end solutions
      </div>
    </div>
  );
};
